// Flow types automatically removed

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import styles from './styles/InteriorsLandingRoomsHeader.scss';
export function InteriorsLandingRoomsHeaderComponent({ roomsHeadModule }) {
    const { imageUrl, title } = roomsHeadModule;

    if (!title || !imageUrl) {
        return null;
    }

    return (
        <div className={styles.wrapper}>
            <span className={styles.barHeader} data-tn="interiors-landing-header-title">
                {title}
            </span>
            <img
                src={imageUrl}
                alt={title}
                className={styles.headerBackground}
                data-tn="interiors-landing-header-image"
            />
        </div>
    );
}
export const InteriorsLandingRoomsHeader = createFragmentContainer(
    InteriorsLandingRoomsHeaderComponent,
    {
        roomsHeadModule: graphql`
            fragment InteriorsLandingRoomsHeader_roomsHeadModule on InteriorsLandingModuleItem {
                linkUrl
                imageUrl
                title
            }
        `,
    }
);
